import React from 'react';
const PipeIntersection1Icon = ({ width = 64, height = 64 }) => {
  const id = React.useId().replace(/:/g, '');
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 112.5 112.5">
      <defs>
        <linearGradient id={`${id}_1`} gradientUnits="userSpaceOnUse" x1="27.25" y1="84.3311" x2="84.75" y2="84.3311">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.18" stopColor="#949494" />
          <stop offset="0.5" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#656565" />
        </linearGradient>
        <linearGradient id={`${id}_2`} gradientUnits="userSpaceOnUse" x1="27.25" y1="28.2451" x2="84.75" y2="28.2451">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.18" stopColor="#949494" />
          <stop offset="0.5" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#656565" />
        </linearGradient>
        <linearGradient id={`${id}_3`} gradientUnits="userSpaceOnUse" x1="35.957" y1="110.376" x2="93.457" y2="110.376" gradientTransform="matrix(0 -1 1 0 -26.126 120.707)">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.16" stopColor="#8F8F8F" />
          <stop offset="0.49" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#646464" />
        </linearGradient>
        <linearGradient id={`${id}_4`} gradientUnits="userSpaceOnUse" x1="18.8335" y1="234.25" x2="77.043" y2="234.25" gradientTransform="matrix(0 1 -1 0 261.375 8.707)">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.16" stopColor="#8F8F8F" />
          <stop offset="0.49" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#646464" />
        </linearGradient>
      </defs>
      <polyline fill={`url(#${id}_1)`} points="84.75,56.162 84.75,112.5 27.25,112.5 27.25,56.491" />
      <polyline fill={`url(#${id}_2)`} points="27.25,56.491 27.25,0 84.75,0 84.75,56.162" />
      <polygon fill={`url(#${id}_3)`} points="84.75,84.75 56,56.25 84.25,27.25 112.5,27.25 112.5,84.75" />
      <polygon fill={`url(#${id}_4)`} points="27.25,27.541 54.25,56.5 27.25,85.75 0,85.541 0,27.541" />
    </svg>
  );
};
export default PipeIntersection1Icon;
